<!-- <app-loader *ngIf="isLoading()" /> -->
<div class="dialog-header">
  <h6>{{ isEditMode ? 'Edit Purpose' : 'Add Purpose' }}</h6>
  <button mat-icon-button class="close-icon" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<form [formGroup]="purposeForm" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="outline">
    <mat-label>Purpose</mat-label>
    <input matInput formControlName="name" (keypress)="disallowNumericData($event);allowLimitedInput($event, 50)"
      (blur)="onInputTrim('name');" (paste)="onPaste($event)" />
    <mat-error *ngIf="purposeForm.get('name')?.hasError('required')">
      Purpose is required.
    </mat-error>
  </mat-form-field>
  <div>
    <button mat-flat-button color="primary" class="add-purpose" type="submit"> {{ isEditMode ? 'Update Purpose' : 'Add
      Purpose' }}</button>
  </div>
</form>